import React from 'react';
import {FaFileCircleExclamation, FaFilePen, FaLocationPin} from "react-icons/fa6";
import {FaClipboardCheck} from "react-icons/fa";
import {useEdgeBuilder} from "../../association-network-context.jsx";
import projectUtils from "../../../../../../utils/project-utils.js";
import I18nKeys from "../i18n-keys.js";
import BaseNode from "./base-node.jsx";
import {getAssetPath} from "../../../../../../utils/get-asset-path.js";
import CheckHasData from "../check-has-data.jsx";

const Occurrence = ({data, selected}) => {
    const {toggleItemsNode} = useEdgeBuilder();
    const icon = (
        <img
            className="m-auto w-[20px]"
            src={getAssetPath("img/dashboard-svg/sw.occurrence.svg")}
            alt="image"
        />
    );

    const title = (
        <>
            <p className={"!mb-[2px]"}><b>Ocorrência</b></p>
            <p className={"mb-0 text-[6px]"}>
                <CheckHasData value={projectUtils.formatDate(data.factDateIni)} />
            </p>
        </>
    )

    const infoBlock = (
        <div className="p-1 text-[7px] border-top border-bottom !border-[#cfcfcf]">
            {
                toggleItemsNode.occurrence.reason &&
                <div className={"flex items-center"}>
                    <FaFileCircleExclamation/>
                    <p className={"ml-1 mb-0 overflow-hidden whitespace-nowrap text-ellipsis w-[calc(100%-10px)]"}>
                        <CheckHasData value={data.reasons} />
                    </p>
                </div>
            }
            {
                toggleItemsNode.occurrence.address &&
                <div className={"flex items-center"}>
                    <FaLocationPin/>
                    <p className={"ml-1 mb-0 overflow-hidden whitespace-nowrap text-ellipsis w-[calc(100%-10px)]"}>
                        <CheckHasData value={data.address} />
                    </p>
                </div>
            }
            {
                toggleItemsNode.occurrence.status &&
                <div className={"flex items-center"}>
                    <FaClipboardCheck/>
                    <p className={"ml-1 mb-0 overflow-hidden whitespace-nowrap text-ellipsis w-[calc(100%-10px)]"}>
                        <CheckHasData value={I18nKeys[data.status] || ""} />
                    </p>
                </div>
            }
            {
                toggleItemsNode.occurrence.description &&
                <div className={"flex items-center"}>
                    <FaFilePen/>
                    <p className={"ml-1 mb-0 overflow-hidden whitespace-nowrap text-ellipsis w-[calc(100%-10px)]"}>
                        <CheckHasData value={data.description} />
                    </p>
                </div>
            }
        </div>
    )

    const handleSearchConnections = () => {
    }

    const open = () =>  projectUtils.openOccurrence(data.id)

    return (
        <BaseNode
            icon={icon}
            title={title}
            image={null}
            infoBlock={infoBlock}
            onSearchConnections={handleSearchConnections}
            onExtraAction={open}
            showAddConnectionButton={true}
            selected={selected}
            bgHeader={"bg-[#67cd8b]"}
            bgBody={"bg-[#f5fff9]"}
        />
    );
};

export default Occurrence;